import truncate from "lodash-es/truncate";
import React from "react";
import { translate } from "src/services/translation.service";
import globalTheme, { media } from "src/theme";
import styled from "styled-components";

import { stripHtml } from "../../../lib/utils/text";

const Description = styled.p`
  font-size: ${globalTheme.fontSizes.small};

  max-width: 600px;
  text-align: center;
  margin: 25px auto;

  ${media.tablet} {
    max-width: initial;
    text-align: left;
  }
`;

const SeeMore = styled.button`
  border: none;
  background: transparent;
  font-size: 11px;
  color: ${globalTheme.colors.grey};
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

const limit = 320;

interface IProps {
  showShortDescription?: boolean;
  shortDescription?: string;
  goToAccordion?: () => void;
}

const ProductShortDescription = ({
  showShortDescription,
  shortDescription,
  goToAccordion,
}: IProps): JSX.Element | null => {
  if (showShortDescription && shortDescription) {
    return (
      <Description>
        <span>{truncate(stripHtml(shortDescription), { length: limit })} </span>
        <SeeMore onClick={goToAccordion}>{translate("global.seeMore")}</SeeMore>
      </Description>
    );
  }

  return null;
};

export default ProductShortDescription;
